import classnames from 'classnames';
import React__default from 'react';
import '../box/index.js';
import { item } from './list.css.js';
import { Box } from '../box/box.js';

/**
 * Creates a single list item to be rendered inside of a List
 */
const ListItem = React__default.forwardRef(function ListItem({ className, ...rest }, ref) {
    return React__default.createElement(Box, { ...rest, className: classnames(item, className), ref: ref, as: "li" });
});

export { ListItem };
